<template>
  <v-app>
    <Header></Header>
    <v-main>
      <v-container fluid class="py-0 pb-3">
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from './components/Header'

export default {
  name: 'MainLayout',
  components: {
    Header
  }
}
</script>
